export default __webpack_public_path__ + "static/media/icon-card-idg.704f8709.svg";